import React, { FC, memo } from 'react';
import Icon from '~ComponentsImproved/Icon';
import { GlassPillBase, GlassPillSize, GLASS_PILL_ICON_SIZE } from './styles';

/** Same look as GlassPill, but static - it states something, it isn't tappable. */
const TagBase = GlassPillBase.withComponent('div');

interface Props {
  icon?: string;
  size?: GlassPillSize;
  className?: string;
  children: React.ReactNode;
}

const GlassTag: FC<Props> = ({ icon, size = 'medium', className, children }) => (
  <TagBase size={size} className={className}>
    {icon && (
      <Icon
        src={icon}
        color="var(--colorWhite)"
        width={GLASS_PILL_ICON_SIZE[size]}
        height={GLASS_PILL_ICON_SIZE[size]}
      />
    )}
    {children}
  </TagBase>
);

export default memo(GlassTag);
